// frontend/src/components/rbac/PermissionMatrix.jsx
import { useMemo, useState } from 'react';

function PermissionMatrix({ allPermissions, selectedPermissions, onChange }) {
  const [searchTerm, setSearchTerm] = useState('');

  const groupedPermissions = useMemo(() => {
    const grouped = allPermissions.reduce((acc, p) => {
      const module = p.module || 'geral';
      if (!acc[module]) {
        acc[module] = [];
      }
      acc[module].push(p);
      return acc;
    }, {});
    return Object.entries(grouped).sort(([a], [b]) => a.localeCompare(b));
  }, [allPermissions]);

  const handleToggleAll = (module, isChecked) => {
    const modulePermissions = groupedPermissions
      .find(([mod]) => mod === module)[1]
      .map(p => p.name);

    let newSelected;
    if (isChecked) {
      newSelected = [...new Set([...selectedPermissions, ...modulePermissions])];
    } else {
      newSelected = selectedPermissions.filter(p => !modulePermissions.includes(p));
    }
    onChange(newSelected);
  };

  const handlePermissionChange = (permissionName, isChecked) => {
    let newSelected;
    if (isChecked) {
      newSelected = [...selectedPermissions, permissionName];
    } else {
      newSelected = selectedPermissions.filter(p => p !== permissionName);
    }
    onChange(newSelected);
  };

  const filteredGroupedPermissions = useMemo(() => {
    if (!searchTerm) return groupedPermissions;
    const term = searchTerm.toLowerCase();
    
    return groupedPermissions.map(([module, permissions]) => {
      const filtered = permissions.filter(p =>
        p.name.toLowerCase().includes(term) ||
        p.description.toLowerCase().includes(term)
      );
      return [module, filtered];
    }).filter(([, permissions]) => permissions.length > 0);

  }, [searchTerm, groupedPermissions]);


  return (
    <div className="permission-matrix">
      <div className="mb-4">
        <input
          type="text"
          className="form-control"
          placeholder="Buscar permissão por nome ou descrição..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="row">
        {filteredGroupedPermissions.map(([module, permissions]) => {
          const modulePermissionsNames = permissions.map(p => p.name);
          const allInModuleSelected = modulePermissionsNames.every(p => selectedPermissions.includes(p));

          return (
            <div key={module} className="col-12 col-md-6 col-lg-4 mb-4">
              <div className="card h-100 permission-module-card">
                <div className="card-header permission-module-header d-flex justify-content-between align-items-center">
                  <h6 className="card-title permission-module-title mb-0 text-capitalize">{module.replace(/_/g, ' ')}</h6>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={`check-all-${module}`}
                      checked={allInModuleSelected}
                      onChange={(e) => handleToggleAll(module, e.target.checked)}
                      title={allInModuleSelected ? 'Desmarcar todos' : 'Marcar todos'}
                    />
                  </div>
                </div>
                <div className="card-body">
                  {permissions.map(p => (
                    <div key={p.id} className="form-check permission-item" title={p.name}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`perm-${p.id}`}
                        value={p.name}
                        checked={selectedPermissions.includes(p.name)}
                        onChange={(e) => handlePermissionChange(p.name, e.target.checked)}
                      />
                      <label className="form-check-label permission-item-label" htmlFor={`perm-${p.id}`}>
                        {p.description}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default PermissionMatrix;
